export const designFastVariables = {
    wheelbase: 1.650,
    relativeVerticalSpeed: 0.050,
    lightHeight: 0.750,
    lightAngle: 1.500,
    computationalEyeHeight: 1.100,
    computationalObjectHeight: 0.250,
    computationalVehicleHeight: 1.250,
    reactionTime: 2.000,
    verticalAcceleration: 0.300,
    airDensity: 1.200,
    rollingResistance: 0.015,
    retardation: 3.000,
    crossSlope: 0.030,
    minCrossSlope: 0.02,

    vehicleLength: 7.000,
    heavyVehicleLength: 13.000
}

export const designRoadClasses = {
    'h1-80':
    {
        id: 'h1-80',
        name: "H1 (80km/t) - Nasjonal hovedveg",
        speedlimit: 80,
        speedAddition: 5.000,
        safetyFactor: 1.000,
        speedProfileAddition: true,
        minHorizontalRadius: 250,
        maxHorizontalRadius: 1750,
        minInitialSpeed: null,
        maxFinalSpeed: null,
        designTable: [
            { minRh: 250,  minA: 125, minRvCrest: 2800, minRvSag: 1900, e: 0.080, s: 0.060 },
            { minRh: 275,  minA: 135, minRvCrest: 2800, minRvSag: 1900, e: 0.080, s: 0.060 },
            { minRh: 300,  minA: 140, minRvCrest: 2800, minRvSag: 1900, e: 0.080, s: 0.060 },
            { minRh: 350,  minA: 150, minRvCrest: 3000, minRvSag: 1900, e: 0.080, s: 0.060 },
            { minRh: 400,  minA: 160, minRvCrest: 3000, minRvSag: 2000, e: 0.080, s: 0.060 },
            { minRh: 450,  minA: 175, minRvCrest: 3000, minRvSag: 2000, e: 0.080, s: 0.060 },
            { minRh: 500,  minA: 180, minRvCrest: 3000, minRvSag: 2000, e: 0.080, s: 0.060 },
            { minRh: 550,  minA: 190, minRvCrest: 3000, minRvSag: 2000, e: 0.080, s: 0.060 },
            { minRh: 600,  minA: 200, minRvCrest: 3000, minRvSag: 2000, e: 0.080, s: 0.060 },
            { minRh: 700,  minA: 215, minRvCrest: 3300, minRvSag: 2000, e: 0.080, s: 0.060 },
            { minRh: 800,  minA: 225, minRvCrest: 3300, minRvSag: 2000, e: 0.075, s: 0.060 },
            { minRh: 900,  minA: 230, minRvCrest: 3300, minRvSag: 2000, e: 0.070, s: 0.060 },
            { minRh: 1000, minA: 235, minRvCrest: 3300, minRvSag: 2100, e: 0.065, s: 0.060 },
            { minRh: 1200, minA: 235, minRvCrest: 3300, minRvSag: 2100, e: 0.056, s: 0.060 },
            { minRh: 1400, minA: 235, minRvCrest: 3300, minRvSag: 2100, e: 0.047, s: 0.060 },
            { minRh: 1600, minA: 235, minRvCrest: 3300, minRvSag: 2100, e: 0.037, s: 0.060 },
            { minRh: 1750, minA: 235, minRvCrest: 3300, minRvSag: 2100, e: 0.030, s: 0.060 }
        ]
    },
    'h1-90':
    {
        id: 'h1-90',
        name: "H1 (90km/t) - Nasjonal hovedveg",
        speedlimit: 90,
        speedAddition: 5.000,
        safetyFactor: 1.000,
        speedProfileAddition: true,
        minHorizontalRadius: 400,
        maxHorizontalRadius: 1750,
        minInitialSpeed: null,
        maxFinalSpeed: null,
        designTable: [
            { minRh: 400,  minA: 175, minRvCrest: 4700, minRvSag: 2300, e: 0.080, s: 0.060 },
            { minRh: 450,  minA: 180, minRvCrest: 4700, minRvSag: 2400, e: 0.080, s: 0.060 },
            { minRh: 500,  minA: 190, minRvCrest: 4700, minRvSag: 2400, e: 0.080, s: 0.060 },
            { minRh: 550,  minA: 200, minRvCrest: 5000, minRvSag: 2400, e: 0.080, s: 0.060 },
            { minRh: 600,  minA: 210, minRvCrest: 5000, minRvSag: 2400, e: 0.080, s: 0.060 },
            { minRh: 700,  minA: 225, minRvCrest: 5000, minRvSag: 2500, e: 0.080, s: 0.060 },
            { minRh: 800,  minA: 235, minRvCrest: 5000, minRvSag: 2500, e: 0.075, s: 0.060 },
            { minRh: 900,  minA: 240, minRvCrest: 5300, minRvSag: 2500, e: 0.070, s: 0.060 },
            { minRh: 1000, minA: 245, minRvCrest: 5300, minRvSag: 2500, e: 0.065, s: 0.060 },
            { minRh: 1200, minA: 250, minRvCrest: 5300, minRvSag: 2500, e: 0.056, s: 0.060 },
            { minRh: 1400, minA: 250, minRvCrest: 5300, minRvSag: 2600, e: 0.047, s: 0.060 },
            { minRh: 1600, minA: 250, minRvCrest: 5300, minRvSag: 2600, e: 0.037, s: 0.060 },
            { minRh: 1750, minA: 250, minRvCrest: 5300, minRvSag: 2600, e: 0.030, s: 0.060 }
        ]
    },
    'h2-90':
    {
        id: 'h2-90',
        name: "H2 (90km/t) - Nasjonal hovedveg",
        speedlimit: 90,
        speedAddition: 5.000,
        safetyFactor: 1.100,
        speedProfileAddition: true,
        minHorizontalRadius: 400,
        maxHorizontalRadius: 1750,
        minInitialSpeed: 50,
        maxFinalSpeed: 50,
        designTable: [
            { minRh: 400,  minA: 175, minRvCrest: 4700, minRvSag: 2300, e: 0.080, s: 0.060 },
            { minRh: 450,  minA: 180, minRvCrest: 4700, minRvSag: 2400, e: 0.080, s: 0.060 },
            { minRh: 500,  minA: 190, minRvCrest: 4700, minRvSag: 2400, e: 0.080, s: 0.060 },
            { minRh: 550,  minA: 200, minRvCrest: 5000, minRvSag: 2400, e: 0.080, s: 0.060 },
            { minRh: 600,  minA: 210, minRvCrest: 5000, minRvSag: 2400, e: 0.080, s: 0.060 },
            { minRh: 700,  minA: 225, minRvCrest: 5000, minRvSag: 2500, e: 0.080, s: 0.060 },
            { minRh: 800,  minA: 235, minRvCrest: 5000, minRvSag: 2500, e: 0.075, s: 0.060 },
            { minRh: 900,  minA: 240, minRvCrest: 5300, minRvSag: 2500, e: 0.070, s: 0.060 },
            { minRh: 1000, minA: 245, minRvCrest: 5300, minRvSag: 2500, e: 0.065, s: 0.060 },
            { minRh: 1200, minA: 250, minRvCrest: 5300, minRvSag: 2500, e: 0.056, s: 0.060 },
            { minRh: 1400, minA: 250, minRvCrest: 5300, minRvSag: 2600, e: 0.047, s: 0.060 },
            { minRh: 1600, minA: 250, minRvCrest: 5300, minRvSag: 2600, e: 0.037, s: 0.060 },
            { minRh: 1750, minA: 250, minRvCrest: 5300, minRvSag: 2600, e: 0.030, s: 0.060 }
        ]
    },
    'h3-90':
    {
        id: 'h3-90',
        name: "H3 (90km/t) - Nasjonal hovedveg",
        speedlimit: 90,
        speedAddition: 10.000,
        safetyFactor: 1.100,
        speedProfileAddition: false,
        minHorizontalRadius: 400,
        maxHorizontalRadius: 1750,
        minInitialSpeed: 70,
        maxFinalSpeed: 70,
        designTable: [
            { minRh: 400,  minA: 175, minRvCrest: 4700, minRvSag: 2300, e: 0.080, s: 0.060 },
            { minRh: 450,  minA: 180, minRvCrest: 4700, minRvSag: 2400, e: 0.080, s: 0.060 },
            { minRh: 500,  minA: 190, minRvCrest: 4700, minRvSag: 2400, e: 0.080, s: 0.060 },
            { minRh: 550,  minA: 200, minRvCrest: 5000, minRvSag: 2400, e: 0.080, s: 0.060 },
            { minRh: 600,  minA: 210, minRvCrest: 5000, minRvSag: 2400, e: 0.080, s: 0.060 },
            { minRh: 700,  minA: 225, minRvCrest: 5000, minRvSag: 2500, e: 0.080, s: 0.060 },
            { minRh: 800,  minA: 235, minRvCrest: 5000, minRvSag: 2500, e: 0.075, s: 0.060 },
            { minRh: 900,  minA: 240, minRvCrest: 5300, minRvSag: 2500, e: 0.070, s: 0.060 },
            { minRh: 1000, minA: 245, minRvCrest: 5300, minRvSag: 2500, e: 0.065, s: 0.060 },
            { minRh: 1200, minA: 250, minRvCrest: 5300, minRvSag: 2500, e: 0.056, s: 0.060 },
            { minRh: 1400, minA: 250, minRvCrest: 5300, minRvSag: 2600, e: 0.047, s: 0.060 },
            { minRh: 1600, minA: 250, minRvCrest: 5300, minRvSag: 2600, e: 0.037, s: 0.060 },
            { minRh: 1750, minA: 250, minRvCrest: 5300, minRvSag: 2600, e: 0.030, s: 0.060 }
        ]
    },
    'h3-100':
    {
        id: 'h3-100',
        name: "H3 (100km/t) - Nasjonal hovedveg",
        speedlimit: 100,
        speedAddition: 10.000,
        safetyFactor: 1.100,
        speedProfileAddition: false,
        minHorizontalRadius: 550,
        maxHorizontalRadius: 1750,
        minInitialSpeed: 70,
        maxFinalSpeed: 70,
        designTable: [
            { minRh: 550,  minA: 215, minRvCrest: 7500, minRvSag: 3100, e: 0.080, s: 0.050 },
            { minRh: 600,  minA: 220, minRvCrest: 7500, minRvSag: 3100, e: 0.080, s: 0.050 },
            { minRh: 700,  minA: 240, minRvCrest: 7500, minRvSag: 3100, e: 0.080, s: 0.050 },
            { minRh: 800,  minA: 250, minRvCrest: 7500, minRvSag: 3100, e: 0.075, s: 0.050 },
            { minRh: 900,  minA: 255, minRvCrest: 7500, minRvSag: 3100, e: 0.070, s: 0.050 },
            { minRh: 1000, minA: 260, minRvCrest: 7500, minRvSag: 3100, e: 0.065, s: 0.050 },
            { minRh: 1200, minA: 265, minRvCrest: 7500, minRvSag: 3100, e: 0.056, s: 0.050 },
            { minRh: 1400, minA: 265, minRvCrest: 7500, minRvSag: 3100, e: 0.047, s: 0.050 },
            { minRh: 1600, minA: 265, minRvCrest: 7500, minRvSag: 3100, e: 0.037, s: 0.050 },
            { minRh: 1750, minA: 265, minRvCrest: 7500, minRvSag: 3100, e: 0.030, s: 0.050 }
        ]
    },
    'h3-110':
    {
        id: 'h3-110',
        name: "H3 (110km/t) - Nasjonal hovedveg",
        speedlimit: 110,
        speedAddition: 10.000,
        safetyFactor: 1.100,
        speedProfileAddition: false,
        minHorizontalRadius: 800,
        maxHorizontalRadius: 1750,
        minInitialSpeed: 70,
        maxFinalSpeed: 70,
        designTable: [
            { minRh: 800,  minA: 260, minRvCrest: 11000, minRvSag: 3700, e: 0.075, s: 0.050 },
            { minRh: 900,  minA: 265, minRvCrest: 11000, minRvSag: 3700, e: 0.070, s: 0.050 },
            { minRh: 1000, minA: 270, minRvCrest: 11000, minRvSag: 3700, e: 0.065, s: 0.050 },
            { minRh: 1200, minA: 275, minRvCrest: 11000, minRvSag: 3700, e: 0.056, s: 0.050 },
            { minRh: 1400, minA: 275, minRvCrest: 11000, minRvSag: 3700, e: 0.047, s: 0.050 },
            { minRh: 1600, minA: 275, minRvCrest: 11000, minRvSag: 3700, e: 0.037, s: 0.050 },
            { minRh: 1750, minA: 265, minRvCrest: 11000, minRvSag: 3700, e: 0.030, s: 0.050 }
        ]
    }
}

export const crossingTypes = {
    acceleration:
    {
        'right-straight': { id: 'right-straight' },
        'right-right': { id: 'right-right' },
        'right-left': { id: 'right-left' },
        'straight-left': { id: 'straight-left' },
        'left-left': { id: 'left-left' },
    },
    retardation:
    {
        'straight-right': { id: 'straight-right' },
        'right-right': { id: 'right-right' },
        'left-right': { id: 'left-right' },
        'left-straight': { id: 'left-straight' },
        'left-left': { id: 'left-left' },
    }
}

export const designVehicles = {
    'personbil':
    {
        id: 'P',
        name: "Personbil",
        maxSpeed: 130,
        effect: 60000,
        mass: 1500,
        airResistance: 0.400,
        frontArea: 2.000,
        maxAcceleration: 2.200,

        minUtilizationRate: 0.40,
        maxUtilizationRate: 0.80,
        minUtilizationRateDelta: 1,
        maxUtilizationRateDelta: 2,
        minUtilizationRateSpeed: 30,
        maxUtilizationRateSpeed: 90,

        wheelbase: 1.65,
        centerOfGravityHeight: 0.5,
        massDistributionFront: 0.6,
        massDistributionRear: 0.4,
        length: 6.000,

        includeInCrossingCalculations: true,
        includeInExtraWideningCalculations: true,
    },
    'litenLastebil':
    {
        id: "LL",
        name: "Liten lastebil",
        includeInCrossingCalculations: false,
        includeInExtraWideningCalculations: true,
        length: 8.000,
    },
    'lastebil':
    {
        id: "L",
        name: "Lastebil",
        includeInCrossingCalculations: false,
        includeInExtraWideningCalculations: true,
        length: 12.000,
    },
    'buss':
    {
        id: "B",
        name: "Buss",
        maxSpeed: 91,
        effect: 180000,
        mass: 10000,
        airResistance: 0.500,
        frontArea: 8.000,
        maxAcceleration: 2.000,

        minUtilizationRate: 0.85,
        maxUtilizationRate: 0.95,
        minUtilizationRateDelta: 0,
        maxUtilizationRateDelta: 0,
        minUtilizationRateSpeed: 30,
        maxUtilizationRateSpeed: 90,
        length: 15.000,

        includeInCrossingCalculations: true,
        includeInExtraWideningCalculations: true,
    },
    'vogntog':
    {
        id: "VT",
        name: "Vogntog",
        maxSpeed: 91,
        effect: 360000,
        mass: 40000,
        airResistance: 0.600,
        frontArea: 8.000,
        maxAcceleration: 1.500,

        minUtilizationRate: 0.85,
        maxUtilizationRate: 0.95,
        minUtilizationRateDelta: 0,
        maxUtilizationRateDelta: 0,
        minUtilizationRateSpeed: 30,
        maxUtilizationRateSpeed: 90,
        length: 22.000,

        includeInCrossingCalculations: true,
        includeInExtraWideningCalculations: true,
    },
    'modulvogntog':
    {
        id: "MVT",
        name: "Modulvogntog",
        includeInCrossingCalculations: false,
        includeInExtraWideningCalculations: true,
        length: 25.250,
    }
}

export const calculationLimits = {
    minSpeed: 30,
    maxSpeed: 120,
    minCrossSlope: -0.150,
    maxCrossSlope: 0.150,
    minLongitudalSlope: -0.200,
    maxLongitudalSlope: 0.200,
    minLightsHeight: 0.100,
    maxLightsHeight: 2,
    minLightsAngle: 0.250,
    maxLightsAngle: 7.5

}

export const mCurves = {
    1:
    {
        week:
        [
            0.860, 0.980, 0.980, 0.970,
            0.990, 0.980, 0.990, 0.930,
            0.970, 1.020, 1.030, 1.060,
            1.050, 1.060, 0.980, 1.070,
            1.080, 1.010, 1.100, 1.000,
            1.060, 1.020, 1.090, 1.100,
            1.080, 1.040, 0.930, 0.840,
            0.770, 0.790, 0.870, 0.870,
            0.960, 1.070, 1.070, 1.070,
            1.060, 1.070, 1.060, 1.020,
            1.060, 1.070, 1.060, 1.060,
            1.040, 1.040, 1.040, 1.040,
            1.050, 1.080, 1.110, 0.650,
            0.650
        ],
        weekday:
        [
            1.070, 1.100, 1.130, 1.130, 1.120, 0.760, 0.700
        ],
        hour:
        [
            0.017, 0.010, 0.006, 0.005,
            0.004, 0.005, 0.010, 0.037,
            0.060, 0.058, 0.049, 0.051,
            0.056, 0.061, 0.065, 0.073,
            0.083, 0.079, 0.067, 0.059,
            0.049, 0.040, 0.033, 0.025
        ]
    },
    2:
    {
        week:
        [
            0.840, 0.920, 0.930, 0.920,
            0.930, 0.920, 0.950, 0.910,
            0.930, 0.960, 0.990, 1.010,
            1.020, 1.020, 0.970, 1.030,
            1.050, 1.000, 1.060, 0.990,
            1.070, 1.050, 1.110, 1.130,
            1.120, 1.120, 1.050, 0.980,
            0.930, 0.940, 1.000, 1.000,
            1.040, 1.080, 1.070, 1.060,
            1.050, 1.050, 1.040, 1.030,
            1.030, 1.040, 1.020, 1.020,
            1.000, 1.000, 1.000, 1.000,
            1.000, 1.040, 1.060, 0.690,
            0.690
        ],
        weekday:
        [
            1.040, 1.070, 1.090, 1.110, 1.120, 0.800, 0.780
        ],
        hour:
        [
            0.017, 0.010, 0.006, 0.004,
            0.004, 0.005, 0.012, 0.037,
            0.053, 0.051, 0.047, 0.051,
            0.057, 0.061, 0.066, 0.073,
            0.084, 0.081, 0.070, 0.060,
            0.050, 0.041, 0.034, 0.025
        ]
    },

    3:
    {
        week:
        [
            0.810, 0.860, 0.870, 0.860,
            0.870, 0.870, 0.910, 0.900,
            0.910, 0.930, 0.950, 0.980,
            1.010, 1.020, 0.950, 0.980,
            1.010, 0.990, 1.030, 1.000,
            1.050, 1.060, 1.090, 1.110,
            1.140, 1.170, 1.150, 1.130,
            1.110, 1.120, 1.130, 1.130,
            1.150, 1.100, 1.080, 1.060,
            1.050, 1.050, 1.050, 1.060,
            1.010, 1.010, 1.000, 0.980,
            0.950, 0.950, 0.950, 0.940,
            0.950, 0.990, 1.020, 0.710,
            0.700
        ],
        weekday:
        [
            1.020, 1.030, 1.050, 1.080, 1.160, 0.810, 0.850
        ],
        hour:
        [
            0.017, 0.010, 0.006, 0.004,
            0.004, 0.005, 0.012, 0.032,
            0.051, 0.050, 0.046, 0.051,
            0.057, 0.061, 0.066, 0.073,
            0.087, 0.085, 0.071, 0.061,
            0.051, 0.042, 0.033, 0.025,
        ]
    },

    4:
    {
        week:
        [
            0.780, 0.800, 0.820, 0.810,
            0.820, 0.830, 0.870, 0.890,
            0.900, 0.890, 0.910, 0.950,
            1.020, 0.970, 0.950, 0.930,
            0.980, 0.980, 1.010, 1.000,
            1.060, 1.080, 1.090, 1.150,
            1.190, 1.250, 1.250, 1.280,
            1.290, 1.280, 1.260, 1.260,
            1.260, 1.140, 1.070, 1.050,
            1.040, 1.020, 1.030, 1.060,
            0.980, 0.960, 0.960, 0.920,
            0.890, 0.890, 0.890, 0.880,
            0.890, 0.920, 0.980, 0.710,
            0.710
        ],
        weekday:
        [
            0.980, 0.970, 1.000, 1.050, 1.200, 0.850, 0.970
        ],
        hour:
        [
            0.015, 0.010, 0.006, 0.004,
            0.004, 0.005, 0.011, 0.028,
            0.041, 0.043, 0.045, 0.051,
            0.059, 0.064, 0.069, 0.076,
            0.089, 0.087, 0.074, 0.064,
            0.053, 0.043, 0.033, 0.024,
        ]
    },

    5:
    {
        week:
        [
            0.750, 0.750, 0.770, 0.750,
            0.770, 0.780, 0.810, 0.860,
            0.870, 0.860, 0.860, 0.880,
            0.980, 0.990, 0.930, 0.880,
            0.930, 0.950, 0.960, 0.980,
            1.040, 1.080, 1.080, 1.160,
            1.220, 1.350, 1.410, 1.500,
            1.540, 1.520, 1.460, 1.460,
            1.390, 1.160, 1.090, 1.050,
            1.020, 1.000, 1.000, 1.070,
            0.960, 0.920, 0.890, 0.880,
            0.820, 0.830, 0.820, 0.810,
            0.810, 0.830, 0.900, 0.720,
            0.700
        ],
        weekday:
        [
            0.960, 0.930, 0.960, 1.030, 1.230, 0.870, 1.020
        ],
        hour:
        [
            0.015, 0.010, 0.007, 0.005,
            0.004, 0.004, 0.008, 0.023,
            0.039, 0.041, 0.044, 0.052,
            0.061, 0.066, 0.071, 0.078,
            0.090, 0.087, 0.075, 0.065,
            0.054, 0.043, 0.033, 0.024,
        ]
    },

    6:
    {
        week:
        [
            0.660, 0.630, 0.640, 0.620,
            0.640, 0.650, 0.690, 0.780,
            0.780, 0.790, 0.750, 0.810,
            0.960, 0.900, 0.920, 0.860,
            0.860, 0.910, 0.920, 0.980,
            1.050, 1.090, 1.090, 1.210,
            1.340, 1.530, 1.680, 1.870,
            1.970, 1.980, 1.840, 1.840,
            1.700, 1.230, 1.100, 1.060,
            1.040, 0.980, 0.990, 1.020,
            0.910, 0.820, 0.810, 0.760,
            0.710, 0.700, 0.690, 0.680,
            0.670, 0.700, 0.790, 0.620,
            0.650
        ],
        weekday:
        [
            0.950, 0.910, 0.950, 1.020, 1.210, 0.870, 1.100
        ],
        hour:
        [
            0.018, 0.012, 0.008, 0.006,
            0.005, 0.005, 0.008, 0.019,
            0.031, 0.038, 0.042, 0.051,
            0.060, 0.065, 0.072, 0.078,
            0.087, 0.086, 0.078, 0.068,
            0.057, 0.047, 0.036, 0.026
        ]
    },

    7:
    {
        week:
        [
            0.540, 0.400, 0.390, 0.400,
            0.410, 0.430, 0.540, 0.510,
            0.650, 0.480, 0.490, 0.620,
            0.920, 0.960, 0.780, 0.680,
            0.710, 0.840, 0.810, 0.940,
            1.080, 1.170, 1.160, 1.330,
            1.660, 1.930, 2.200, 2.570,
            2.820, 2.840, 2.500, 2.500,
            2.240, 1.430, 1.180, 1.130,
            1.060, 0.890, 0.950, 1.060,
            0.780, 0.660, 0.650, 0.550,
            0.500, 0.500, 0.430, 0.450,
            0.440, 0.440, 0.560, 0.480,
            0.420
        ],
        weekday:
        [
            0.910, 0.810, 0.860, 0.950, 1.250, 0.920, 1.300
        ],
        hour:
        [
            0.017, 0.014, 0.008, 0.006,
            0.004, 0.004, 0.005, 0.008,
            0.014, 0.022, 0.036, 0.050,
            0.064, 0.075, 0.079, 0.087,
            0.090, 0.092, 0.083, 0.072,
            0.061, 0.048, 0.035, 0.025,
        ]
    },

}

export const signalDurations = [
    {
        traffic: 100,
        values: [
            {emptyingTime: 6, greenTime: 6, cycleTime: 30},
            {emptyingTime: 10, greenTime: 6, cycleTime: 38},
            {emptyingTime: 20, greenTime: 6, cycleTime: 58},
            {emptyingTime: 30, greenTime: 6, cycleTime: 78},
            {emptyingTime: 40, greenTime: 6, cycleTime: 98},
            {emptyingTime: 50, greenTime: 6, cycleTime: 118},
        ]
    },
    {
        traffic: 200,
        values: [
            {emptyingTime: 6, greenTime: 6, cycleTime: 30},
            {emptyingTime: 10, greenTime: 6, cycleTime: 38},
            {emptyingTime: 20, greenTime: 6, cycleTime: 58},
            {emptyingTime: 30, greenTime: 6, cycleTime: 78},
            {emptyingTime: 40, greenTime: 8, cycleTime: 102},
            {emptyingTime: 50, greenTime: 10, cycleTime: 126},
        ]
    },
    {
        traffic: 300,
        values: [
            {emptyingTime: 6, greenTime: 6, cycleTime: 30},
            {emptyingTime: 10, greenTime: 6, cycleTime: 38},
            {emptyingTime: 20, greenTime: 7, cycleTime: 60},
            {emptyingTime: 30, greenTime: 10, cycleTime: 86},
            {emptyingTime: 40, greenTime: 13, cycleTime: 112},
            {emptyingTime: 50, greenTime: 16, cycleTime: 138},
        ]
    },
    {
        traffic: 400,
        values: [
            {emptyingTime: 6, greenTime: 6, cycleTime: 30},
            {emptyingTime: 10, greenTime: 6, cycleTime: 38},
            {emptyingTime: 20, greenTime: 10, cycleTime: 66},
            {emptyingTime: 30, greenTime: 14, cycleTime: 94},
            {emptyingTime: 40, greenTime: 19, cycleTime: 124},
        ]
    },
    {
        traffic: 500,
        values: [
            {emptyingTime: 6, greenTime: 6, cycleTime: 30},
            {emptyingTime: 10, greenTime: 8, cycleTime: 42},
            {emptyingTime: 20, greenTime: 14, cycleTime: 74},
            {emptyingTime: 30, greenTime: 20, cycleTime: 106},
            {emptyingTime: 40, greenTime: 26, cycleTime: 138},
        ]
    },
    {
        traffic: 600,
        values: [
            {emptyingTime: 6, greenTime: 8, cycleTime: 34},
            {emptyingTime: 10, greenTime: 11, cycleTime: 48},
            {emptyingTime: 20, greenTime: 19, cycleTime: 84},
            {emptyingTime: 30, greenTime: 27, cycleTime: 120},
        ]
    },
    {
        traffic: 700,
        values: [
            {emptyingTime: 6, greenTime: 10, cycleTime: 38},
            {emptyingTime: 10, greenTime: 14, cycleTime: 54},
            {emptyingTime: 20, greenTime: 25, cycleTime: 96},
            {emptyingTime: 30, greenTime: 36, cycleTime: 138},
        ]
    },
    {
        traffic: 800,
        values: [
            {emptyingTime: 6, greenTime: 14, cycleTime: 46},
            {emptyingTime: 10, greenTime: 19, cycleTime: 64},
            {emptyingTime: 20, greenTime: 34, cycleTime: 114},
        ]
    },
    {
        traffic: 900,
        values: [
            {emptyingTime: 6, greenTime: 18, cycleTime: 54},
            {emptyingTime: 10, greenTime: 26, cycleTime: 78},
            {emptyingTime: 20, greenTime: 46, cycleTime: 138},
        ]
    },
    {
        traffic: 1000,
        values: [
            {emptyingTime: 6, greenTime: 28, cycleTime: 74},
            {emptyingTime: 10, greenTime: 37, cycleTime: 100},
        ]
    },
    {
        traffic: 1100,
        values: [
            {emptyingTime: 6, greenTime: 40, cycleTime: 98},
            {emptyingTime: 10, greenTime: 57, cycleTime: 140},
        ]
    }
];